type SofaEntry = {
  id: string
  rangeId: string
}

export class SceneHistoryMap {
  get size(): number {
    return this.map.size
  }

  private readonly map = new Map<string, SofaEntry>()

  addOrMoveToEnd(entry: SofaEntry) {
    if (this.map.has(entry.id)) {
      this.map.delete(entry.id)
    }
    this.map.set(entry.id, entry)
  }

  canGoBackward(sofaId: string) {
    const index = this.indexOf(sofaId)
    return index !== null && index > 0
  }

  canGoForward(sofaId: string) {
    const index = this.indexOf(sofaId)
    return index !== null && index < this.map.size - 1
  }

  clear() {
    this.map.clear()
  }

  getNext(sofaId: string) {
    const index = this.indexOf(sofaId)
    if (index === null || !this.canGoForward(sofaId)) return undefined
    return [...this.map.values()][index + 1]
  }

  getPrevious(sofaId: string) {
    const index = this.indexOf(sofaId)
    if (index === null || !this.canGoBackward(sofaId)) return undefined
    return [...this.map.values()][index - 1]
  }

  indexOf(sofaId: string): null | number {
    let index = 0
    for (const key of this.map.keys()) {
      if (key === sofaId) return index
      index++
    }
    return null
  }

  toArray(): SofaEntry[] {
    return [...this.map.values()]
  }
}
